import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { createClient as createCoreStructuredContentClient } from '@nerdwallet/structured-content-core';
import nerdwalletSchema from './schema';
import nerdwalletComponents from './components';
import createNerdwalletProviders from './create-providers';
export default function createClient() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      nwApiSdk = _ref.nwApiSdk,
      appConfig = _ref.appConfig,
      serverRequest = _ref.serverRequest,
      apolloClient = _ref.apolloClient,
      _ref$createProviders = _ref.createProviders,
      createProviders = _ref$createProviders === void 0 ? createNerdwalletProviders : _ref$createProviders,
      _ref$components = _ref.components,
      components = _ref$components === void 0 ? nerdwalletComponents : _ref$components,
      _ref$schema = _ref.schema,
      schema = _ref$schema === void 0 ? nerdwalletSchema : _ref$schema,
      isomorphicState = _ref.isomorphicState,
      dataProviders = _ref.dataProviders;

  var providers = createProviders({
    serverRequest: serverRequest,
    apolloClient: apolloClient,
    schema: schema,
    nwApiSdk: nwApiSdk,
    appConfig: appConfig
  });
  return _objectSpread(_objectSpread({}, createCoreStructuredContentClient({
    schema: schema,
    components: components,
    providers: providers,
    isomorphicState: isomorphicState,
    dataProviders: dataProviders
  })), {}, {
    serverRequest: serverRequest
  });
}